import type * as React from "react";
import { Box, Typography } from "@mui/material";
import { SxProps } from "@mui/system";
import { COLORS } from "components/v3/Theme/colors";
import GLButton from "components/v3/sharedComponents/GLButton";

type DashboardAlternateCtaCardProps = {
  header: React.ReactNode | string;
  subheader: React.ReactNode | string;
  link: React.HTMLProps<HTMLAnchorElement> & {
    onClick: () => void;
    overrideClick?: boolean;
    text: string;
    url: string;
    buttonId?: string;
  };
  sx?: SxProps;
};

const DashboardAlternateCtaCard: React.FC<DashboardAlternateCtaCardProps> = ({
  header,
  link,
  sx,
  subheader
}) => {
  return (
    <Box
      component="a"
      href={link.url}
      onClick={(event) => {
        if (link.overrideClick) {
          event.preventDefault();
        }

        link.onClick();
      }}
      sx={{
        alignItems: {
          md: "center"
        },
        background: COLORS.ACCENT1,
        borderRadius: "24px 24px 24px 4px",
        boxSizing: "border-box",
        display: "flex",
        flexDirection: {
          xs: "column",
          md: "row"
        },
        gap: {
          xs: 4
        },
        margin: "auto",
        maxWidth: "800px",
        padding: "30px",
        textDecoration: "none",
        width: "100%",
        ...sx
      }}
      {...(link.target ? { target: link.target } : {})}
    >
      <Box
        sx={{
          display: "flex",
          flexBasis: "60%",
          flexDirection: "column",
          gap: "30px"
        }}
      >
        <Typography variant="h5_white">{header}</Typography>
        <Typography variant="body_white">{subheader}</Typography>
      </Box>
      <Box
        sx={{
          display: "flex",
          flexGrow: {
            md: 1
          },
          justifyContent: {
            md: "flex-end"
          }
        }}
      >
        <GLButton
          id={link.buttonId}
          buttonType="secondary-transparent"
          sx={{
            border: `1px solid ${COLORS.WHITE}`,
            height: "auto !important",
            paddingX: 3,
            paddingY: 1,
            "&:hover": {
              backgroundColor: "transparent",
              borderRadius: "16px 8px 16px 16px"
            }
          }}
        >
          <Typography variant="body_strong_white">{link.text}</Typography>
        </GLButton>
      </Box>
    </Box>
  );
};

export default DashboardAlternateCtaCard;
